import { Brand } from '@shared-utils/types/common.types';
export const getAgencyProximity = (distance) => {
    if (distance >= 100 && distance < 500) {
        return '500 m';
    }
    else if (distance < 100) {
        return '100 m';
    }
    return `${Math.ceil(distance / 1000)} km`;
};
export const getAgencyRating = (rating, brand) => {
    switch (brand) {
        case Brand.IWB:
            return Number((rating / 20).toFixed(1));
        default:
            return Number(rating.toFixed(1));
    }
};
